ui-cms-container {
  display: block;

  ui-container {
    height: 100%;

    > *:not(ui-cms-anchor) {
      margin-top: 30px;
    }

    > *:first-child,
    > ui-cms-anchor ~ :nth-child(2) {
      margin-top: 0;
    }
  }

  ui-cms-slider {
    + ui-cms-anchor {
      + ui-cms-teaser-group,
      + ui-cms-teaser {
        margin-top: 60px;
      }
    }

    + ui-cms-teaser-group,
    + ui-cms-teaser {
      margin-top: 60px;
    }
  }

  ui-cms-headline:first-child {
    margin-top: -9px;
  }

  ui-cms-headline {
    word-wrap: break-word;
  }

  &.width--25 {
    float: left;
    margin-bottom: 12px;
    margin-right: 3.212%;
    width: 25%;
  }

  &.width--33 {
    float: left;
    margin-bottom: 12px;
    margin-right: 3.212%;
    width: 33%;
  }

  &.white {
    ui-cms-table {
      --main-bg-color: #{$ui-white};
    }
  }

  &.border {
    ui-cms-table {
      --main-bg-color: #{$ui-white};
    }
  }

  &.primary {
    ui-cms-table {
      --main-bg-color: #{$ui-blue};
    }
  }

  &.primary100 {
    ui-cms-table {
      --main-bg-color: #{$ui-blue-minus-5};
    }
  }

  &.secondary100 {
    ui-cms-table {
      --main-bg-color: #{$ui-grey-minus-3};
    }
  }
}
